import { render, staticRenderFns } from "./FeaturesSection.vue?vue&type=template&id=9bb94cc2&"
import script from "./FeaturesSection.vue?vue&type=script&lang=ts&"
export * from "./FeaturesSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports